import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SupportButton' })({
    common: {
        background: '#fff !important',
        color: '#5F5F5F',
        border: '1px solid #ECECEC !important'
    },
    regular: {
        padding: '14px 16px',
        borderRadius: 12,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        boxSizing: 'border-box'
    },
    icon: {
        width: 24,
        height: 24,
        padding: 7,
        boxSizing: 'content-box'
    }
});
